import { useState } from 'react'

import { YesNoRadioGroup } from '~/shadcn/ui/yes-no-radio-group'
import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { StepHeadline } from '~/@pages_onboarding/_onboarding-stepper/StepHeadline'
import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'
import { Button } from '~/shadcn/ui/button/button'
import { useQuestionsV1 } from './questions'

type Props = {
  onTakeTest(isSophisticatedInvestor: boolean): void
  onLeave(): void
}

export function InitialScreen({ onTakeTest, onLeave }: Props) {
  const { initial: initialQuestion } = useQuestionsV1()
  const [isSophisticatedInvestor, setIsSophisticatedInvestor] =
    useState<boolean>()

  return (
    <div className="flex flex-col gap-10">
      <div className="flex justify-between items-center">
        <BackButton onClick={onLeave}>Späť</BackButton>
      </div>
      <div className="flex flex-col gap-5">
        <StepHeadline headingText="Analýza potrieb investora" />
        <p className="font-medium">
          Sme veľmi radi, že ste sa rozhodli investovať do slovenských
          výnosových projektov. Aby sme dokázali porozumieť Vašim investičným
          preferenciám, odpovedzte, prosím, na niekoľko otázok v našom dotazníku
          investora.
        </p>
      </div>
      <p className="text-[32px] leading-[42px] font-semibold">
        {initialQuestion.question.label}
      </p>
      <YesNoRadioGroup
        defaultValue={undefined}
        value={isSophisticatedInvestor}
        labelYes={initialQuestion.answers.true.label}
        labelNo={initialQuestion.answers.false.label}
        onValueChange={(value) => setIsSophisticatedInvestor(value)}
      />
      <div className="flex items-center gap-2">
        <TextTooltip
          triggerClassname="font-semibold"
          text={
            '"Sofistikovaný investor" je termín, ktorý sa používa na označenie investora s pokročilým stupňom skúseností, vedomostí a finančnej pôsobnosti v oblasti investícií. Tento typ investora má často odborné znalosti v súvisiacej oblasti alebo skúsenosti s rôznymi typmi investícií.'
          }
          triggerContent="Čo znamená sofistikovaný investor?"
        />
      </div>
      <Button
        disabled={isSophisticatedInvestor === undefined}
        className="w-full md:w-fit"
        variant="accent"
        size="3xl"
        onClick={() => onTakeTest(!!isSophisticatedInvestor)}>
        Pokračovať
        <ArrowForwardIcon className="ml-2" />
      </Button>
    </div>
  )
}
